export const LogoMark = ({ className = "h-10 w-10" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="14" fill="#0B0D10" />
    <circle
      cx="32" cy="32" r="21"
      fill="none" stroke="#F59E0B" strokeWidth="5"
      strokeDasharray="5 4.5" strokeLinecap="round"
    />
    <path
      d="M32 17.5l4.5 9.1 10 1.5-7.2 7.1 1.7 10-9-4.7-9 4.7 1.7-10-7.2-7.1 10-1.5z"
      fill="#F59E0B"
    />
  </svg>
);

export default function Logo({ markClass = "h-10 w-10" }) {
  return (
    <a href="/" data-testid="logo-link" className="flex items-center gap-2.5 group shrink-0" aria-label="بنشر متنقل نجم الإطار — الرئيسية">
      <LogoMark className={`${markClass} transition-transform duration-700 group-hover:rotate-[72deg]`} />
      <span className="leading-tight">
        <span className="block font-display font-black text-white text-xl">نجم الإطار</span>
        <span className="block text-[10px] text-gold-soft font-semibold tracking-[0.2em]">بنشر متنقل — الرياض</span>
      </span>
    </a>
  );
}
